import { IPerson, IResponse } from "@common/models";
import Api, { IOptions } from "@service/Api";
import { Action } from "./Proxy";

export function customerPerson<T = any, U = any>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    const url = "CustomerPerson";
    switch (action) {
        case Action.GET:
            return Api.get<T, U>(url, { ...options, raiseError: options?.raiseError ?? false });
        case Action.POST:
            return Api.post<T, U>(url, { ...options, raiseError: options?.raiseError ?? true, captchaRequierd: options?.captchaRequierd ?? true });
        case Action.PUT:
            return Api.post<T, U>(`${url}/Modify`, { ...options, raiseError: options?.raiseError ?? true, captchaRequierd: options?.captchaRequierd ?? true });
        case Action.DEL:
            return Api.del<T, U>(`${url}/${(options?.data as IPerson)?.guid}`, { ...options, raiseError: options?.raiseError ?? true });
    }
}